const BLACKOUT_DATES = [
  {month: 0, day: 1},
  {month: 0, day: 15},
  {month: 1, day: 19},
  {month: 2, day: 27},
  {month: 5, day: 19},
  {month: 6, day: 4},
  {month: 8, day: 2},
  {month: 10, day: 11},
  {month: 10, day: 28},
  {month: 11, day: 24},
  {month: 11, day: 25},
  {month: 11, day: 31},
]

const MALO_BLACKOUT_DATE_START = dateFns.addDays(new Date(2025, 11, 16), -1) // Dec 19 2025 to
const MALO_BLACKOUT_DATE_END   = dateFns.addDays(new Date(2026, 0,  5), 1) // Jan 5 2026 inclusive

const CUSTOM_BLACKOUT_DATE_START = dateFns.addDays(new Date(2025, 11, 22), -1)
const CUSTOM_BLACKOUT_DATE_END = dateFns.addDays(new Date(2026, 0, 1), 1)

const blackoutToDate = (blackout) => {
  return new Date(dateFns.getYear(new Date(Date.now())), blackout.month, blackout.day)
}

const isBlackoutDate = (date) => {
  return BLACKOUT_DATES.some((b) => dateFns.isSameDay(date, blackoutToDate(b)))
}

const isCustomBlackoutDate = (date) => {
  return (
    dateFns.isBefore(date, CUSTOM_BLACKOUT_DATE_END) &&
    dateFns.isAfter(date, CUSTOM_BLACKOUT_DATE_START)
  )
}

const isMaloBlackoutDate = (date) => {
  return (
    dateFns.isBefore(date, MALO_BLACKOUT_DATE_END) &&
    dateFns.isAfter(date, MALO_BLACKOUT_DATE_START)
  )
}

const isBusinessWeekday = (date) => {
  const dayOfWeek = dateFns.getDay(date)
  return dayOfWeek !== 5 && dayOfWeek !== 6 && dayOfWeek !== 0
}

// @returns true iff the date passed in is not a friday, saturday, or sunday
const isValidShipDate = (date) => {
  return isBusinessWeekday(date) && !isBlackoutDate(date)
}

const EOD_CUTOFF = 12

const interpretCohort = (label) => {
  // WARNING: the default cohort is the longest: '20 days'
  let graceDays = 20
  let graceIsBusinessDays = true // default to true and let any cohort that needs calendar days override it.

  const raw = String(label).trim()

  const calendarMatch = raw.match(/(\d+)\s*calendar\s*days?/i)
  const isMaloBlackout = !!raw.match(/Malo blackout/i)
  const isCustomBlackout = !!raw.match(/20 days/i)

  // For things like "2 days", "7 days", etc.
  graceDays = parseInt(raw, 10)

  if (calendarMatch) {
    graceDays = parseInt(calendarMatch[1], 10)
    graceIsBusinessDays = false
  } else {
    switch (raw) {
      case '1 (13 days)':
        graceDays = 13
        break
      case '2 (13 days + Malo blackout)':
        graceDays = 13
        break
      case '3 (21 days + Malo blackout)':
        graceDays = 21
        break
    }
  }
  return { graceDays, graceIsBusinessDays, isMaloBlackout, isCustomBlackout }
}

// return the next date we can expect to ship the product by
//
// for all categories, we do not ship on Friday, Saturday, or Sunday
// EOD Cutoff for shipping is 12:00 MST
//
// @returns a formatted string of the next ship date for the given product type
window.getShipByDate = function getShipByDate(shipByCohorts) {
  // general approach:
  // - determine what "shipping day" we are currently in (depending on EOD this is either today or the next business day)
  // - determine how much time the product takes to ship
  // - add the correct number of business or calendar days (depends on the cohort) to the current shipping day
  // - if the product is subject to the Malo Blackout those days don't count as business days or calendar days
  // - after adding all days (business or calendar) determine if the day is a valid ship date. 
  // - if we have landed on an invalid day move forward one business day and check again.
  // - rinse and repeat until valid.
  let candidates = []
  for(const shipByCohort of shipByCohorts) {
        // skip empty / missing cohorts
    if (!shipByCohort || Object.keys(shipByCohort)?.length === 0) continue

    const { graceDays, graceIsBusinessDays, isMaloBlackout, isCustomBlackout } = interpretCohort(shipByCohort)

    // First determine if we are before or after the EOD cutoff
    let candidate = Date.now()
    let todaysCutoff = dateFns.startOfHour(dateFns.setHours(candidate, EOD_CUTOFF))
    if (dateFns.isAfter(candidate, todaysCutoff)) {
      // we are past the EOD cutoff. next earliest start date is next business day
      candidate = dateFns.addBusinessDays(candidate, 1)
    }

    let addDayMethod = dateFns.addBusinessDays
    if (!graceIsBusinessDays) addDayMethod = dateFns.addDays

    // because grace days are not business days we are going to use the addDay method to process our grace days
    let remaining = graceDays
    while (remaining > 0) {
      if (
        (isMaloBlackout && isMaloBlackoutDate(candidate)) || // only skip malo blackout dates if it is a malo blackout cohort
        (isCustomBlackout && isCustomBlackoutDate(candidate)) || // only skip custom blackout dates if it is a custom cohort
        isBlackoutDate(candidate) // skip all blackout dates
      ) {
        // skip this day in our grace day count because we don't count blackout days toward our grace day count
      } else {
        remaining -= 1
      }
      candidate = addDayMethod(candidate, 1)
    }

    // now we have identified our best case scenario shipping date and we need to verify that it is valid.
    while (!isValidShipDate(candidate)) {
        // if it isn't, bump us forward one business day
       candidate = dateFns.addBusinessDays(candidate, 1)
    }

    candidates.push(candidate)
  }
  
  // format and return the date found
  return candidates.length ? dateFns.format(dateFns.max(candidates), 'eeee, MMMM d') : null
}
